import React, { Component, useState } from "react";
import { connect } from "react-redux";
import { assessmentActions, userActions } from "../../../_actions";
import Dashboard from "../Dashboard/Dashboard";
import moment from 'moment';
import { MdOutlineArrowBack } from "react-icons/md";
import Heading from "../../AdminPanel/Component/UI/Heading";
import SelectOption from "../../AdminPanel/Component/UI/SelectOption";
import VideoCourse from "../../AssessmentOverview/VideoCourse/VideoCourse";

class MyVideos extends Component {

  constructor(props) {
    super(props);
    this.state = {
      surveyLanguageCode: 'en',
      surveyLanguageName: 'English',
      surveyLanguageRTL: false,
      crrTeamId: localStorage.getItem("crrTeamId") || ""
    };
  }

  componentDidMount() {
    this.props.dispatch(assessmentActions.userAssessmentUserProfile());
    this.props.dispatch(assessmentActions.getTalentResources({}, "admin"));

    const { crrTeamId } = this.state;
    const temp2 = {
      keyWord: "",
      pageNo: 1,
      size: 100000
    }
    this.props.dispatch(assessmentActions.getCompletedTeamList(temp2, "teamreport", crrTeamId));
  }

  logout = () => {
    this.props.dispatch(assessmentActions.AssessmentUserLogout(this.props));
  };
  switchToSelf = () => {
    this.props.dispatch(userActions.userCoachSwitchLogin({}, this.props));
  };



  handleTeamChange = (value) => {
    localStorage.setItem("crrTeamId", value);
    this.setState({ crrTeamId: value }, () => {
      const paginationData = {
        teamId: value,
        isAll: true,
        type: "TeamTop5Summary"
      };

      const pagination2Data = {
        teamId: value,
        isAll: false,
        type: "TeamTop5Summary"
      };

      this.props.dispatch(
        assessmentActions.getAssessmentReportByTeamId(paginationData)
      );
      this.props.dispatch(
        assessmentActions.getAssessmentReportByTeamIdV2(pagination2Data)
      );
      this.props.dispatch(
        assessmentActions.getAllUserAssessmentByTeamId(paginationData)
      );
    });
  };



  render() {
    let { crrTeamId } = this.state;
    const { assessment, questions } = this.props;
    const { getTranslateElementAllData } = questions;
    const { getTalentResourcesData, getCompletedTeamListData, getAssessmentReportByTeamIdData, getAllUserAssessmentByTeamIdData, userAssessmentUserProfileData } = assessment;
    let { surveyLanguageCode, surveyLanguageRTL } = this.state;


    const GetTextByLanguage = (name, text) => {
      if (surveyLanguageCode && surveyLanguageCode !== "en") {
        let sentence = "";
        if (getTranslateElementAllData && getTranslateElementAllData.length > 0) {
          let getIndex = getTranslateElementAllData.findIndex(prev => prev.name === name);
          if (getIndex !== -1) {
            sentence = getTranslateElementAllData && getTranslateElementAllData[getIndex] && getTranslateElementAllData[getIndex]["transl"] && getTranslateElementAllData[getIndex]["transl"][surveyLanguageCode] ? getTranslateElementAllData[getIndex]["transl"][surveyLanguageCode] : ""
          }
        }
        return sentence ? sentence : text
      } else {
        return text
      }
    }

    const GetDetailsByLanguage = (element, name, text) => {
      if (surveyLanguageCode && surveyLanguageCode !== "en") {
        let sentence = element && element["details"] && element["details"]["transl"] && element["details"]["transl"][surveyLanguageCode] && element["details"]["transl"][surveyLanguageCode][name] ?
          element["details"]["transl"][surveyLanguageCode][name] : ""
        return sentence ? sentence : text
      } else {
        return text
      }
    }

    function EditButtonFn(name, text) {
      return (
        <>
          {GetTextByLanguage(name, text)}
        </>
      )
    }

    function EditDetailsFn(element, name, text) {
      return (
        <>
          {GetDetailsByLanguage(element, name, text)}
        </>
      )
    }


    let createdAt = "";
    let showPageType = '2'

    const getPeriod = () => {
      const hour = moment().hour(); // 0–23

      if (hour >= 5 && hour < 12) return "Morning";
      if (hour >= 12 && hour < 17) return "Afternoon";
      if (hour >= 17 && hour < 21) return "Evening";
      return "Night";
    };

    let userDetails = {
      name: userAssessmentUserProfileData?.name ?? "",
      email: userAssessmentUserProfileData?.email ?? "",
      period: getPeriod()
    };
    let { loading } = assessment;

    const teamNameListData = getCompletedTeamListData && getCompletedTeamListData.length > 0 ? getCompletedTeamListData.map((ele) => ({ value: ele.id, label: ele.name })) : [];

    function hexToRgbA(hex, opacity) {
      var c;
      if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split("");
        if (c.length == 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = "0x" + c.join("");
        return (
          "rgba(" +
          [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
          "," +
          opacity +
          ")"
        );
      }
      throw hex;
    }
    let themeType = 2
    function getTheme(field, init) {
      if (themeType === 2) {

        if (field === "backgroundImage") {
          return 'url("/img/survey-light-bg.webp")'
        }
        else if (field === "welcomeImage") {
          return "url('/img/assessment-welcome-large.webp')"
        }
        else if (field === "text") {
          return '#3D405B'
        }
        else if (field === "lightblue") {
          return hexToRgbA('#2196F3', '0.12')
        }
        else if (field === "textblue") {
          return '#2196F3'
        }
        else if (field === "lightblue") {
          return hexToRgbA('#2196F3', '0.12')
        }
        else if (field === "hoverActive") {
          return 'hover:bg-[' + hexToRgbA('#2196F3', '0.12') + '] hover:border-[#2196F3] hover:text-[#2196F3] '
        }
        else if (field === "grayheader") {
          return ' bg-[' + hexToRgbA('#3D405B', '0.05') + '] '
        }
        else if (field === "textOption") {
          return 'border-[#3D405B] text-[#3D405B] '
        }
        else {
          return init
        }

      } else {
        return init
      }
    }



    return (
      <Dashboard userDetails={userDetails} logout={this.logout} switchToSelf={this.switchToSelf} loading={loading}>
        <div className="space-y-6 p-8">

          <div className="flex justify-between items-center pt-5">
            <div className="flex items-center gap-3">
              <div className="bg-white hover:text-[#1976D2] textblack border border-[#D1D5DB] p-1.5 rounded-full cursor-pointer" onClick={() => this.props.history.goBack()}>
                <MdOutlineArrowBack size={26} className="inline-block" />
              </div>
              <Heading className="text-2xl font-bold text-gray-900" title="Talent Insight" />
            </div>

            <div className="w-64">
              <SelectOption
                name="teamId"
                value={crrTeamId}
                onChange={(e) => this.handleTeamChange(e.target.value)}
                placeholder="Select Team"
                options={teamNameListData}
              />
            </div>
          </div>

          {getAssessmentReportByTeamIdData && getAssessmentReportByTeamIdData.length > 0 ?
            <VideoCourse
              getTalentResourcesData={getTalentResourcesData}
              getAssessmentReportByEmpIDData={getAssessmentReportByTeamIdData}
              crrSelectedEmp={{ name: "Team" }}
              EditButtonFn={EditButtonFn}
              EditDetailsFn={EditDetailsFn}
              getTheme={getTheme}
              closeVideoCourse={this.closeVideoCourse}
              showReportModal={""}
              showSummaryReport={""}
              surveyLanguageRTL={""}
            />
            :
            <div className="grid grid-cols-1 md:grid-cols-1 gap-6">
              <div className="bg-white border border-dashed border-[#D1D5DB] rounded-xl p-6 flex flex-col items-center justify-center text-center min-h-[260px]">
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-gray-100 mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-7 w-7 text-gray-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 17v-2a4 4 0 014-4h2M9 5h6m2 0a2 2 0 012 2v10a2 2 0 01-2 2H7a2 2 0 01-2-2V7a2 2 0 012-2h10z"
                    />
                  </svg>
                </div>

                <p className="text-base font-semibold textblack mb-1">
                  Data not available
                </p>
                <p className="text-sm textlight max-w-xs">
                  No assessment data has been recorded yet. Once assessments are completed,
                  your talent snapshot will appear here.
                </p>
              </div>
            </div>
          }



        </div>
      </Dashboard>
    );
  }
}

function mapStateToProps(state) {
  //console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { questions, users, assessment } = state;
  return {
    loggingIn,
    questions,
    users,
    assessment
  };
}
export default connect(mapStateToProps)(MyVideos);
